import { gql } from "@apollo/client";

const Devices = gql`
  query AvailableDevices {
    allDevices(condition: { isActive: true }, orderBy: DEVICE_NAME_ASC) {
      nodes {
        id
        deviceName
      }
    }
  }
`;

const hash = "db90577199beee44e897d8c7ca1b2723d5940e9ad97d26d65bf25a0438946cbb";

export { Devices, hash };
